<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      v-if="permisos_function(item.permisos)"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import { getPermisosLS } from '@/shared/helpers'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'
import axios from "@/libs/axios";

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      permisos: [],
    }
  },
  created() {
    this.setToken()
  },
  mounted () {
    // this.setVerticalNavMenuWidth()
    this.getPermisos()
  },
  methods: {
    permisos_function(array) {
      return array.some(r => this.permisos.includes(r))
      // return true
    },

    
    getPermisos() {
      this.mostrarLoader = true;

      const permisosLS = getPermisosLS();

      if (permisosLS) {
        this.permisos = permisosLS;
        return;
      }

      axios.post('api', {
        query: `{
          permisos{
            permisos_usuario: permisosUsuario,
            status,
            message,
          }
        }`,
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.permisos.status === 'success') {
            if (response.data.data.permisos.permisos_usuario) {
              this.permisos = response.data.data.permisos.permisos_usuario
            }
          }
        }
      })
    },
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}` // for all requests
    },
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>
